import { Form } from '@unform/web';
import React, { useEffect, useState } from 'react';
import { FaBell, FaCertificate, FaCheckCircle, FaExclamationCircle, FaEye, FaFile, FaFileExcel, FaIdBadge, FaImages, FaQuestionCircle, FaReceipt, FaRegIdBadge, FaSubscript, FaTable, FaTicketAlt, FaTrophy, FaUser } from 'react-icons/fa';
import { FiFilter, FiMessageCircle, FiPieChart, FiXCircle } from 'react-icons/fi';

import { IconType } from 'react-icons/lib';
import { useAuth } from '../../../../hooks/Auth';
import { useConfiguration } from '../../../../hooks/Configuration';
import api from '../../../../services/api';



import { Container, ContainerWhite } from './styles';
import { useParams } from 'react-router-dom';
import { useModal } from '../../../../hooks/Modal';

import { useLoading } from '../../../../hooks/LoadingHook';
import Chart from '../../../../components/ChartModule';
import { formatReal } from '../../../../utils/format';
import { simpleDateBR } from '../../../../utils/date';
import { convertToXLSX } from 'src/utils/download';
import { MdMenu } from 'react-icons/md';
import ChartPie from 'src/components/Charts/Pie';
import ListFilters from './modules/ListFilters';
import { getDate } from 'date-fns';


const getPaymentMethod = {
  boleto: 'Boleto',
  cortesy: 'Cortesia',
  courtesy: 'Cortesia',
  credit_card: 'Cartão de crédito',
  pix: 'PIX'
}


const SaleListProduct: React.FC<Record<string, any>> = ({ accessType, project, sales, products, coupons, courtesies }) => {

  const [filterCourtesy, setFilterCourtesy] = useState('');
  const { user } = useAuth();
  const { addLoading, removeLoading } = useLoading();
  const { addModal } = useModal();
  const [filterCoupon, setFilterCoupon] = useState('');
  const [filterProduct, setFilterProduct] = useState('');

  const [contador, setContador] = useState(5)

  const [filter, setFilter] = useState('');

  const [filterText, setFilterText] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [filterPaymentMethod, setFilterPaymentMethod] = useState('');
  const [filterCredenciado, setFilterCredenciado] = useState(false);
  const [categoryList, setCategoryList] = useState<Array<string>>([]);
  const [groupData, setGroupData] = useState('');
  const [filterCategory, setFilterCategory] = useState('');
  const [activeMenu, setActiveMenu] = useState(false);
  const [activeFilterMenu, setActiveFilterMenu] = useState('');
  const [filterCompany, setFilterCompany] = useState('');
  const [filterPosition, setFilterPosition] = useState('');
  const [filterCountry, setFilterCountry] = useState('');
  const [filterState, setFilterState] = useState('');
  const [filterCity, setFilterCity] = useState('');

  const [companyList, setCompanyList] = useState<string[]>([]);
  const [positionList, setPositionList] = useState<string[]>([]);
  const [countryList, setCountryList] = useState<string[]>([]);
  const [stateList, setStateList] = useState<string[]>([]);
  const [cityList, setCityList] = useState<string[]>([]);


  const productsFields = products?.reduce((prev, item) => {


    if (item?.fields?.length > 0) {

      item?.fields?.map(field => {

        const index = prev.findIndex(i => i?.field === field?.field)

        if (index < 0) {

          prev.push({
            title: field?.title,
            field: field?.field
          })

        }

      })


    }


    return prev;

  }, [])


  const groupList = [

    { value: 'product_id', label: 'Inscrição' },
    { value: 'payment_method_id', label: 'Forma de pagamento' },
    { value: 'payment_status_id', label: 'tatus de pagamento' },
    { value: 'checkin', label: 'Credenciados' },
    { value: 'coupon', label: 'Cupons' },
    { value: 'courtesy_hash', label: 'Cortesias' },
    { value: 'category_id', label: 'Categoria' },
    { value: 'company', label: 'Empresa' },
    { value: 'position', label: 'Cargo' },
    { value: 'country', label: 'Países' },
    { value: 'state', label: 'Estado' },
    { value: 'city', label: 'Cidade' },


  ]

  const filtersList = [
    { title: 'Produto', column: 'product_id', value: filterProduct, changeValue: setFilterProduct },
    { title: 'Status de pagamento', column: 'payment_status_id', value: filterStatus, changeValue: setFilterStatus },
    { title: 'Forma de pagamento', column: 'payment_method_id', value: filterPaymentMethod, changeValue: setFilterPaymentMethod },
    { title: 'Credenciamento', column: 'reference', value: filterCredenciado, changeValue: setFilterCredenciado },
    { title: 'Cupom', column: 'coupon', value: filterCoupon, changeValue: setFilterCoupon },
    { title: 'Cortesia', column: 'courtesy_hash', value: filterCourtesy, changeValue: setFilterCourtesy },
    { title: 'Categoria', column: 'category_id', value: filterCategory, changeValue: setFilterCategory },
    { title: 'Empresa', column: 'company', value: filterCompany, changeValue: setFilterCompany },
    { title: 'Cargo', column: 'position', value: filterPosition, changeValue: setFilterPosition },
    { title: 'País', column: 'country', value: filterCountry, changeValue: setFilterCountry },
    { title: 'Estado', column: 'state', value: filterState, changeValue: setFilterState },
    { title: 'Cidade', column: 'city', value: filterCity, changeValue: setFilterCity },
  ]


  useEffect(() => {

    const list: any = {
      category_id: [],
      company: [],
      position: [],
      country: [],
      state: [],
      city: []
    }



    if (sales?.length > 0) {

      sales?.map(i => {

        const category_id = (i?.client_id_response?.category_id || 'Não informado')?.toUpperCase();
        const company = (i?.client_id_response?.company || 'Não informado')?.toUpperCase();
        const position = (i?.client_id_response?.position || 'Não informado')?.toUpperCase();
        const country = (i?.client_id_response?.country || 'Não informado')?.toUpperCase();
        const state = (i?.client_id_response?.state || 'Não informado')?.toUpperCase();
        const city = (i?.client_id_response?.city || 'Não informado')?.toUpperCase();

        const indexcategory_id = list?.category_id?.findIndex(a => a === category_id);
        const indexcompany = list?.company?.findIndex(a => a === company);
        const indexposition = list?.position?.findIndex(a => a === position);
        const indexcountry = list?.country?.findIndex(a => a === country);
        const indexstate = list?.state?.findIndex(a => a === state);
        const indexcity = list?.city?.findIndex(a => a === city);

        if (indexcategory_id < 0) {
          list?.category_id.push(category_id)
        }
        if (indexcompany < 0) {
          list?.company.push(company)
        }
        if (indexposition < 0) {
          list?.position.push(position)
        }
        if (indexcountry < 0) {
          list?.country.push(country)
        }
        if (indexstate < 0) {
          list?.state.push(state)
        }
        if (indexcity < 0) {
          list?.city.push(city)
        }
      })


      setCategoryList(list?.category_id);
      setCompanyList(list?.company);
      setPositionList(list?.position);
      setCountryList(list?.country);
      setStateList(list?.state);
      setCityList(list?.city);
    }
  }
    , [sales]);
  const headerList = accessType === 'Completo' ? [
    'Credenciado',
    'Produto',
    'Status',
    'Nome',
    'Categoria',
    'E-mail',
    'Telefone',
    'Data de nascimento',
    'CPF',
    'Empresa',
    'Cargo',
    'Como soube do evento',
    'Cupom',
    'Cortesia',
    'Campos adicionais',
    'Confirmação de pagamento',
    'Data da compra / inscrição'

  ] : [

    'Credenciado',
    'Produto',
    'Status',
    'Nome',
    'Categoria',

    'Empresa',
    'Cargo',
    'Como soube do evento',
    'Cupom',
    'Cortesia',
    'Campos adicionais',
    'Confirmação de pagamento',
    'Data da compra / inscrição'


  ]

  const [ignoreUnclaimedCourtesies, setIgnoreUnclaimedCourtesies] = useState(false);
  const salesFiltered = sales?.filter(sale => {
    const client = sale?.client_id_response || {};
    const name = client?.name?.toLowerCase() || '';
    const document = client?.document_number || '';
    const know_about = client?.know_about || '';
    const company = client?.company?.toLowerCase() || '';
    const position = client?.position?.toLowerCase() || '';
    const status = sale?.payment_status_id || '';
    const method = sale?.payment_method_id || '';
    const couponHash = sale?.coupon || '';
    const courtesyHash = sale?.cortesy_hash_id || '';
    const courtesy = sale?.cortesy || '';
    const category_id = sale?.category_id || '';



    const matchText =
      name.includes(filterText) ||
      document.includes(filterText) ||
      company.includes(filterText) ||
      position.includes(filterText) ||
      couponHash.includes(filterText) ||
      courtesy.includes(filterText) ||
      courtesy.includes(filterText) ||
      category_id.includes(filterText) ||
      know_about.includes(filterText)

    const matchStatus = filterStatus ? status === filterStatus : true;
    const matchPayment = filterPaymentMethod ? method === filterPaymentMethod : true;
    const matchCoupon = filterCoupon ? couponHash === filterCoupon : true;
    const matchCourtesy = filterCourtesy ? courtesyHash === filterCourtesy : true;
    const matchProduct = filterProduct ? sale?.product_id_response?._id === filterProduct : true;


    const matchUnclaimedCourtesy = ignoreUnclaimedCourtesies
      ? (sale?.courtesy && !sale?.client_id) ? false : true
      : true;

    const isCredenciado = sale?.client_id_response?.checkin === 'Sim';

    const matchCredenciado =
      filterCredenciado ? isCredenciado : true;


    const matchCategory = filterCategory ? sale?.client_id_response?.category_id?.toLowerCase()?.trim() === filterCategory?.toLowerCase()?.trim() : true;
    const matchCompany = filterCompany ? company?.toLowerCase()?.trim() === filterCompany?.toLowerCase()?.trim() : true;
    const matchPosition = filterPosition ? position?.toLowerCase()?.trim() === filterPosition?.toLowerCase()?.trim() : true;
    const matchCountry = filterCountry ? client?.country?.toLowerCase()?.trim() === filterCountry?.toLowerCase()?.trim() : true;
    const matchState = filterState ? client?.state?.toLowerCase()?.trim() === filterState?.toLowerCase()?.trim() : true;
    const matchCity = filterCity ? client?.city?.toLowerCase()?.trim() === filterCity?.toLowerCase()?.trim() : true;

    return matchText &&
      matchStatus &&
      matchPayment &&
      matchCoupon &&
      matchCourtesy &&
      matchProduct &&
      matchUnclaimedCourtesy &&
      matchCredenciado &&
      matchCategory &&
      matchCompany &&
      matchPosition &&
      matchCountry &&
      matchState &&
      matchCity;
  }).sort((a, b) => {
    const nameA = a?.client_id_response?.name || '';
    const nameB = b?.client_id_response?.name || '';
    return nameA.localeCompare(nameB);
  });


  const getGroupRealInfo = (group, item) => {

    if (group === 'category_id' || group === 'company' || group === 'position' ||
      group === 'country' || group === 'state' || group === 'city') {
      return item?.client_id_response?.[group]?.trim()?.toUpperCase() || 'Não informado';
    }

    if (group === 'product_id') {
      return item?.product_id_response?.title?.trim()?.toUpperCase() || 'Não informado';
    }


    if (group === 'payment_status_id') {
      if (item?.[group] === 'paid') { return 'Pago'; }
      else if (item?.[group] === 'waiting') { return 'Aguardando pagamento'; }

    }
    if (group === 'payment_method_id') {
      if (item?.[group] === 'credit_card') { return 'Cartão de crédito'; }
      else if (item?.[group] === 'pix') { return 'PIX'; }
      else if (item?.[group] === 'boleto') { return 'Boleto'; }
      else { return 'Gratuito'; }
    }

    return item?.[group];

  }

  const salesGroupFiltered = groupData ? salesFiltered?.reduce((prev, item) => {
    const groupTitle = getGroupRealInfo(groupData, item);
    const index = prev.findIndex(i => i?.title === groupTitle);

    if (index < 0) {
      prev.push({ title: groupTitle, count: 1 })
    }
    else {
      prev[index].count += 1;
    }

    return prev;

  }, []) : [];

  salesGroupFiltered?.sort((a, b) => a?.count < b?.count ? 1 : a?.count > b?.count ? -1 : 0)

  const totalGroup = salesGroupFiltered?.reduce((prev, item) => {
    return prev + (item?.count || 0)
  }, 0)

  const downloadXLSX = (data) => {


    const exportHeader = [...headerList];

    productsFields?.map(field => {
      exportHeader.push(field?.title)


    })

    const list = [exportHeader]

    console.log(list)
    salesFiltered.map(sale => {

      const content = accessType === 'Completo' ?
        [
          sale?.checkin || 'Não',
          sale?.product_id_response?.title || '',
          sale?.payment_status_id_title || '',
          sale?.client_id_response?.name || '',
          sale?.client_id_response?.category_id || '',
          sale?.client_id_response?.email || '',
          sale?.client_id_response?.phone || '',
          sale?.client_id_response?.extra_1 ? sale?.client_id_response?.extra_1 : sale?.client_id_response?.birth_date ? simpleDateBR(sale?.client_id_response?.birth_date) : '',
          sale?.client_id_response?.document_number || '',
          sale?.client_id_response?.company || '',
          sale?.client_id_response?.position || '',
          sale?.client_id_response?.know_about || '',
          sale?.coupon || '',
          sale?.courtesy || '',
          sale?.fields_text || '',
          sale?.approved_at ? simpleDateBR(sale?.approved_at) : '',
          sale?.createdAt ? simpleDateBR(sale?.createdAt) : '',

        ] : [
          sale?.checkin || 'Não',
          sale?.product_id_response?.title || '',
          sale?.payment_status_id_title || '',
          sale?.client_id_response?.name || '',
          sale?.client_id_response?.category_id || '',


          sale?.client_id_response?.company || '',
          sale?.client_id_response?.position || '',
          sale?.client_id_response?.know_about || '',
          sale?.coupon || '',
          sale?.courtesy || '',
          sale?.fields_text || '',
          sale?.approved_at ? simpleDateBR(sale?.approved_at) : '',
          sale?.createdAt ? simpleDateBR(sale?.createdAt) : '',

        ];


      productsFields?.map(field => {




        content.push(sale?.fields?.[field?.field] || '')


      })



      list.push(content)
    })

    convertToXLSX(list);

  }




  const openFields = (sale: Record<string, any>) => {

    const items: JSX.Element[] = [];

    sale?.product_id_response?.fields?.map(doc => {

      const value = sale?.fields?.[doc.field];

      items?.push(


        <tr><th style={{ color: '#333', textAlign: 'left' }}>{doc?.title}</th><td style={{ color: '#333', textAlign: 'left' }}>{doc.type === 'image' ? <a style={{ color: '#333', cursor: 'pointer' }} href={value} download> <button type='button' className="defaultButtonMini">Download</button></a> : <>{value}</>}</td></tr>



      )

    })



    addModal({
      title: '', content: <>
        <p><strong style={{ color: '#333', fontSize: '16px' }}>Dados complementares</strong></p>
        <p style={{ color: '#333', marginTop: '10px' }}>Nome: {sale?.client_id_response?.name}</p>
        <p style={{ color: '#333', marginBottom: '10px' }}>CPF: {sale?.client_id_response?.document_number}</p>
        <table className='tableRef' ><tbody> {items}</tbody></table>
      </>, theme: 'whiteModalMedium'
    });


  }

  return <Container>




    <div className='row-to-column' style={{ width: '100%', maxWidth: '1600px', justifyContent: 'space-between' }}>
      <h2 style={{ width: '300px' }}>Lista de inscrições</h2>

      <div className='searchFilters row' style={{ width: '100%', maxWidth: '1600px', justifyContent: 'flex-end' }}>

        <p style={{ color: '#333' }}>{salesFiltered.length} registros</p>

        <button className="button" onClick={downloadXLSX}>
          <FaFileExcel /> Exportar
        </button>

        <input style={{ maxWidth: '350px' }}
          placeholder="Buscar por nome, CPF, empresa, cargo..."
          onChange={e => setFilterText(e.target.value.toLowerCase())}
        />

        <button className="button" style={{ background: activeFilterMenu === 'filter' ? '#4e5768' : '#ddd', color: activeFilterMenu === 'filter' ? '#fff' : '#4e5768' }} title='Filtros' onClick={() => {

          if (activeFilterMenu === 'chart') {
            setGroupData('');
          }

          setActiveFilterMenu(activeFilterMenu === 'filter' ? '' : 'filter')

        }}>
          <FiFilter />
        </button>

        <button className="button" style={{ background: activeFilterMenu === 'chart' ? '#4e5768' : '#ddd', color: activeFilterMenu === 'chart' ? '#fff' : '#4e5768' }} title='Filtros' onClick={() => {

          if (activeFilterMenu === 'chart') {
            setGroupData('');
          }
          else {
            setGroupData('product_id');

          }

          setActiveFilterMenu(activeFilterMenu === 'chart' ? '' : 'chart')


        }}>
          <FiPieChart />
        </button>
      </div>





    </div>

    <ListFilters products={products} list={filtersList} />

    <div className='row-to-column gap-xs' style={{ alignItems: 'flex-start', justifyContent: 'center', width: '100%' }}>

      <div className='column full-width' style={{ width: '100%', maxWidth: '1600px', alignItems: 'flex-start', overflowX: 'auto' }}>

        {activeFilterMenu === 'filter' ? <div className='row-to-column-start gap-sm fadeIn' style={{ alignItems: 'flex-start', background: '#4e5768', padding: '30px 20px' }}>
          <div className='searchFilters ' style={{ width: '100%', maxWidth: '300px' }}>

            <p style={{ color: '#fff', fontWeight: 'bold' }}>Filtros Gerais</p>
            <div className='selectCard' style={{ background: '#fff' }}>
              <p style={{ color: '#333' }}>Somente credenciados</p>
              <div className="toggleFilter">
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={filterCredenciado}
                    onChange={e => { setFilterCredenciado(e.target.checked) }}
                  />
                  <span className="slider round"></span>
                </label>

              </div>
            </div>

            <div className='selectCard' style={{ background: '#fff' }}>
              <p style={{ color: '#333' }}>Ignorar cortesias não retiradas</p>
              <div className="toggleFilter">
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={ignoreUnclaimedCourtesies}
                    onChange={e => { setIgnoreUnclaimedCourtesies(e.target.checked) }}
                  />
                  <span className="slider round"></span>
                </label>

              </div>
            </div>





          </div>

          <div className='searchFilters ' style={{ width: '100%', maxWidth: '300px' }}>

            <p style={{ color: '#fff', fontWeight: 'bold' }}>Filtros de inscrição</p>

            <div className='selectCard column-start' style={{ background: '#fff' }}>
              <p style={{ color: '#333', marginTop: '10px' }}>Inscrição</p>
              <select value={filterProduct} onChange={e => setFilterProduct(e.target.value)}>
                <option value="">Todas as inscrições</option>
                {products?.map(product => (
                  <option key={product._id} value={product._id}>{product.title}</option>
                ))}
              </select>
            </div>
            <div className='selectCard column-start' style={{ background: '#fff' }}>
              <p style={{ color: '#333', marginTop: '10px' }}>Status de pagamento</p>
              <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)}>
                <option value="">Todos os status</option>
                <option value="paid">Pago</option>
                <option value="waiting">Aguardando</option>
              </select>
            </div>
            <div className='selectCard column-start' style={{ background: '#fff' }}>
              <p style={{ color: '#333', marginTop: '10px' }}>Forma de pagamento</p>
              <select value={filterPaymentMethod} onChange={e => setFilterPaymentMethod(e.target.value)}>
                <option value="">Todas formas de pagamento</option>
                <option value="credit_card">Cartão de crédito</option>
                <option value="boleto">Boleto</option>
                <option value="pix">PIX</option>
                <option value="gratuito">Gratuito</option>
                <option value="courtesy">Cortesia</option>
              </select>
            </div>
            <div className='selectCard column-start' style={{ background: '#fff' }}>
              <p style={{ color: '#333', marginTop: '10px' }}>Cupons de desconto</p>
              <select value={filterCoupon} onChange={e => setFilterCoupon(e.target.value)}>
                <option value="">Todos os cupons</option>
                {coupons?.map(coupon => (
                  <option key={coupon.hash} value={coupon.hash}>{coupon.title}</option>
                ))}
              </select>
            </div>
            <div className='selectCard column-start' style={{ background: '#fff' }}>
              <p style={{ color: '#333', marginTop: '10px' }}>Cortesias</p>
              <select value={filterCourtesy} onChange={e => setFilterCourtesy(e.target.value)}>
                <option value="">Todas as cortesias</option>
                {courtesies?.map(courtesy => (
                  <option key={courtesy.hash} value={courtesy.hash}>{courtesy.title || courtesy.hash}</option>
                ))}
              </select>
            </div>



          </div>

          <div className='searchFilters ' style={{ width: '100%', maxWidth: '300px' }}>

            <p style={{ color: '#fff', fontWeight: 'bold' }}>Filtros de cadastro</p>
            <div className='selectCard column-start' style={{ background: '#fff' }}>
              <p style={{ color: '#333', marginTop: '10px' }}>País</p>
              <select value={filterCountry} onChange={e => setFilterCountry(e.target.value)}>
                <option value="">Todos</option>
                {countryList.map((country) => <option key={country} value={country}>{country}</option>)}
              </select>
            </div>
            <div className='selectCard column-start' style={{ background: '#fff' }}>
              <p style={{ color: '#333', marginTop: '10px' }}>Estado</p>
              <select value={filterState} onChange={e => setFilterState(e.target.value)}>
                <option value="">Todos</option>
                {stateList.map((state) => <option key={state} value={state}>{state}</option>)}
              </select>
            </div>
            <div className='selectCard column-start' style={{ background: '#fff' }}>
              <p style={{ color: '#333', marginTop: '10px' }}>Cidade</p>
              <select value={filterCity} onChange={e => setFilterCity(e.target.value)}>
                <option value="">Todas</option>
                {cityList.map((city) => <option key={city} value={city}>{city}</option>)}
              </select>
            </div>
            <div className='selectCard column-start' style={{ background: '#fff' }}>
              <p style={{ color: '#333', marginTop: '10px' }}>Empresa</p>
              <select value={filterCompany} onChange={e => setFilterCompany(e.target.value)}>
                <option value="">Todas</option>
                {companyList.map((company) => <option key={company} value={company}>{company}</option>)}
              </select>
            </div>
            <div className='selectCard column-start' style={{ background: '#fff' }}>
              <p style={{ color: '#333', marginTop: '10px' }}>Cargo</p>
              <select value={filterPosition} onChange={e => setFilterPosition(e.target.value)}>
                <option value="">Todos</option>
                {positionList.map((position) => <option key={position} value={position}>{position}</option>)}
              </select>
            </div>
          </div>

        </div> : <></>}
        {activeFilterMenu === 'chart' ? <div className='row-to-column-start gap-sm fadeIn' style={{ alignItems: 'flex-start', background: '#4e5768', padding: '30px 20px' }}>
          <div className='searchFilters ' style={{ width: '100%', maxWidth: '400px' }}>

            <div className='selectCard row-start' style={{ alignItems: 'center', background: '#fff' }}>
              <p style={{ color: '#333', marginTop: '10px' }}>Agrupar dados por:</p>
              <select value={groupData} onChange={e => setGroupData(e.target.value)}>
                <option value="">Não agrupar</option>

                <option key={'product_id'} value={'product_id'}>Inscrição</option>
                <option key={'payment_method_id'} value={'payment_method_id'}>Forma de pagamento</option>
                <option key={'payment_status_id'} value={'payment_status_id'}>Status de pagamento</option>
                <option key={'checkin'} value={'checkin'}>Credenciados</option>
                <option key={'coupon'} value={'coupon'}>Cupons</option>
                <option key={'courtesy_hash'} value={'courtesy_hash'}>Cortesias</option>
                <option key={'category_id'} value={'category_id'}>Categoria</option>
                <option key={'company'} value={'company'}>Empresa</option>
                <option key={'position'} value={'position'}>Cargo</option>
                <option key={'country'} value={'country'}>Países</option>
                <option key={'state'} value={'state'}>Estado</option>
                <option key={'city'} value={'city'}>Cidades</option>
              </select>
            </div>


          </div>
          <div className='searchFilters ' style={{ width: '100%', maxWidth: '300px' }}>


            <div className='selectCard' style={{ background: '#fff' }}>
              <p style={{ color: '#333' }}>Somente credenciados</p>
              <div className="toggleFilter">
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={filterCredenciado}
                    onChange={e => { setFilterCredenciado(e.target.checked) }}
                  />
                  <span className="slider round"></span>
                </label>

              </div>
            </div>
          </div>
          <div className='searchFilters ' style={{ width: '100%', maxWidth: '300px' }}>

            <div className='selectCard' style={{ background: '#fff' }}>
              <p style={{ color: '#333' }}>Ignorar cortesias não retiradas</p>
              <div className="toggleFilter">
                <label className="switch">
                  <input
                    type="checkbox"
                    checked={ignoreUnclaimedCourtesies}
                    onChange={e => { setIgnoreUnclaimedCourtesies(e.target.checked) }}
                  />
                  <span className="slider round"></span>
                </label>

              </div>
            </div>
          </div>


        </div> : <></>}
        <>
          {!groupData ? <table className='tableRef full-width'   >
            <tbody>
              <tr>


                <th>Inscrição</th>
                <th>Comprador</th>
                <th>Participante</th>
                <th>Categoria / Doc</th>
                <th>Empresa</th>
                <th >Cidade / Estado</th>

                <th >Cupom / Cortesia</th>
                <th >Data de criação / Pagamento</th>
                <th style={{ maxWidth: '40px' }}>Cred.</th>
                <th style={{ maxWidth: '40px' }}></th>
              </tr>
              {salesFiltered.map(sale => {

                const fieldsLength = Object.keys(sale?.fields || {}).length;



                return <tr>

                  <td>
                    <div className='column-start gap-xs'>
                      <p style={{ textAlign: 'left', fontWeight: 'bold' }}>{sale?.product_id_response?.title}</p>
                      <p style={{ textAlign: 'left', fontWeight: 'bold' }}>{getPaymentMethod?.[sale?.payment_method_id] ? getPaymentMethod?.[sale?.payment_method_id] : sale?.payment_method_id}</p>
                      <p>{sale?.payment_status_id_title === 'Pago' ? <button style={{ background: 'green', padding: '5px', fontSize: '0.85rem', border: '0px', borderRadius: '5px', color: '#fff' }}>Pago</button> :
                        <button style={{ background: 'orange', color: '#fff', padding: '5px', fontSize: '0.85rem', border: '0px', borderRadius: '5px', }}>Aguardando</button>}</p>

                    </div>
                  </td>
                  <td>
                    <div className='column-start gap-xs'>
                      <p style={{ textAlign: 'left', fontWeight: 'bold' }}>{sale?.payer_id_response?.name}</p>
                    </div>
                  </td>
                  <td>
                    <div className='column-start gap-xs'>
                      <p style={{ textAlign: 'left', fontWeight: 'bold' }}>  {sale?.client_id_response?.name}</p>
                      {accessType === 'Completo' ? <>
                        <p>  {sale?.client_id_response?.email}</p>
                        <p>  {sale?.client_id_response?.phone}</p></> : <></>}

                      {sale?.client_id_response?.know_about ? <p>Como soube do evento: {sale?.client_id_response?.know_about}</p> : <></>}
                    </div>
                  </td>
                  <td>
                    <div className='column-start gap-xs'>
                      <p style={{ textAlign: 'left', fontWeight: 'bold' }}>  {sale?.client_id_response?.category_id}</p>
                      {accessType === 'Completo' ? <p style={{ textAlign: 'left' }}>Doc: {sale?.client_id_response?.document_number}</p> : <></>}
                      {accessType === 'Completo' ? <p style={{ textAlign: 'left' }}>Data de nascimento: {sale?.client_id_response?.extra_1 ? sale?.client_id_response?.extra_1 : sale?.client_id_response?.birth_date ? simpleDateBR(sale?.client_id_response?.birth_date) : ''}</p> : <></>}
                    </div>
                  </td>


                  <td>
                    <div className='column-start gap-xs'>
                      <p style={{ textAlign: 'left', fontWeight: 'bold' }}>  {sale?.client_id_response?.company}</p>

                      <p>{sale?.client_id_response?.position}</p>
                    </div>
                  </td>
                  <td>
                    <div className='column-start gap-xs'>
                      <p style={{ textAlign: 'left', fontWeight: 'bold' }}>  {sale?.client_id_response?.state}</p>

                      <p>{sale?.client_id_response?.city}</p>
                    </div>
                  </td>
                  <td>
                    <div className='column-start gap-xs'>
                      <p style={{ textAlign: 'left', fontWeight: 'bold' }}>  {sale?.coupon ? `Cupom: ${sale?.coupon}` : ''} </p>
                      <p>{sale?.courtesy ? `Cortesia: ${sale?.courtesy}` : ''}</p>
                    </div>
                  </td>
                  <td>
                    <div className='column-start gap-xs'>
                      {sale?.createdAt ? <><p style={{ textAlign: 'left', fontWeight: 'bold' }}>Data de criação: {simpleDateBR(sale?.createdAt)}</p></> : <></>}

                      {sale?.approved_at ? <p style={{ textAlign: 'left', fontWeight: 'bold' }}>Data de pg:{simpleDateBR(sale?.approved_at)}</p> : <></>}
                    </div>

                  </td>
                  <td>
                    <div className='row-start gap-xs'>
                      {sale?.checkin === 'Sim' ? <FaCheckCircle style={{ color: 'green', width: '50px', fontSize: '32px' }} /> : <FiXCircle style={{ color: 'red', width: '50px', fontSize: '32px' }} />}
                    </div>
                  </td>
                  <td>
                    {fieldsLength > 0 ? <button className='iconButtonRef' onClick={() => openFields(sale)}><FaEye style={{ fontSize: '24px', color: '#333', cursor: 'pointer' }} /></button> : <></>}

                  </td>

                </tr>

              })}

            </tbody>
          </table> : <></>}

          {groupData ? <div className='row-to-column'>




            <table className='tableRef full-width'   >
              <tbody>
                {/*   <tr><th></th><th><FaFileExcel /> Exportar resumo</th></tr> */}
                <tr><th>{groupList?.find(i => i?.value === groupData)?.label || ''}</th><th>Qtd</th></tr>
                {salesGroupFiltered.map(group => {


                  return <tr>

                    <td>
                      {group?.title}
                    </td>

                    <td>
                      {group?.count}
                    </td>


                  </tr>

                })}
                <tr><th>Total</th><th>{totalGroup}</th></tr>
              </tbody>
            </table>

          </div> : <></>}

        </>
      </div>

    </div >
  </Container >






}
export default SaleListProduct;
